'use client'

import { useVirtualizer } from '@tanstack/react-virtual'
import { ProjectPost } from '../../masterfeed/_components/project-post'
import { useInView } from 'framer-motion'
import type { Project } from '../../masterfeed/page-client'
import * as React from 'react'
import { PostProjectInputSection } from '../../masterfeed/_components/post-project-input/post-project-input-section'
import { SocialToaster } from '../../masterfeed/_components/social-toaster'

export const PageClient = ({
  userFeed,
  hasNextPage,
  fetchNextPage,
  slug,
}: {
  userFeed: Project[]
  hasNextPage: boolean
  fetchNextPage: () => void
  slug?: string
}) => {
  //   const parentRef = React.useRef<HTMLDivElement | null>(null)
  const sentinelRef = React.useRef<HTMLDivElement | null>(null)
  const isInView = useInView(sentinelRef, { margin: '1000px', once: false })

  // Virtualizer for efficient rendering
  const rowVirtualizer = useVirtualizer({
    count: userFeed?.length ?? 0,
    getScrollElement: () => document.documentElement,
    estimateSize: () => 500,
    overscan: 5,
    getItemKey: index => userFeed?.[index]?.id ?? index,
  })

  React.useEffect(() => {
    if (isInView && hasNextPage) {
      fetchNextPage?.()
    }
  }, [isInView, hasNextPage, fetchNextPage])

  return (
    // <div>{JSON.stringify(userFeed, null, 2)}</div>
    <div className="flex w-full flex-col">
      <div className="mb-4 sm:mb-0">
        <PostProjectInputSection slug={slug || ''} />
      </div>
      <div className="flex w-full flex-col gap-6 sm:gap-4">
        {rowVirtualizer.getVirtualItems().map((virtualItem, index) => {
          const post = userFeed?.[virtualItem.index]
          return (
            <div
              data-index={index}
              key={`feed-post-${post.id}`}
              ref={rowVirtualizer.measureElement}
              className="bg-cf-white relative mx-auto flex h-fit w-full flex-col rounded-[12px] border border-[#E2E4E9] p-4 tablet:pt-6 lg:max-w-[756px]"
            >
              <ProjectPost project={post} />
            </div>
          )
        })}
        <div ref={sentinelRef} className="h-10 w-full" />
        <SocialToaster />
      </div>
    </div>
  )
}
